module.exports = __webpack_public_path__ + "img/hopways-02.6e7265bc.jpg";